import { motion } from 'framer-motion';

export const HeroSection = ({ profile }) => {
    return (
        <div className="relative w-full pt-6 px-5">
            <motion.div
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
                className="relative w-full rounded-3xl overflow-hidden shadow-[0_10px_40px_-10px_rgba(251,113,133,0.35)] ring-1 ring-rose-300/10"
            >
                {/* Rectangular landscape banner photo */}
                <div className="relative w-full aspect-[3/4] overflow-hidden bg-[#1a0a10]">
                    <img
                        data-testid="hero-cover-image"
                        src={profile.profile_image}
                        alt={profile.name}
                        className="w-full h-full object-cover object-[center_18%]"
                        fetchpriority="high"
                        decoding="async"
                    />

                    {/* soft top gradient */}
                    <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black/40 to-transparent pointer-events-none" />

                    {/* soft bottom gradient for legibility */}
                    <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#0a0608] via-[#0a0608]/85 to-transparent pointer-events-none" />

                    {/* subtle rose glow */}
                    <div className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-[280px] h-[140px] bg-rose-400/25 blur-[90px] rounded-full pointer-events-none" />

                    {/* Name + bio overlay (bottom of photo) */}
                    <div className="absolute inset-x-0 bottom-0 px-6 pb-5 text-center">
                        <h1
                            data-testid="profile-name"
                            className="font-heading text-[2.6rem] leading-none font-bold text-white"
                            style={{ textShadow: '0 2px 20px rgba(251, 113, 133, 0.45)' }}
                        >
                            {profile.name}
                        </h1>
                        <p
                            data-testid="profile-bio"
                            className="mt-2 text-rose-100/85 text-sm tracking-wide"
                        >
                            {profile.bio}
                        </p>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default HeroSection;
